import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';
import Select from './components/TypSelect.vue';

export const Typ = {
	name: NAME,
	apiProvider,
	router,
	components: {
		Select,
	},
};
